import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { Text } from '@components/index';
import { StyledDiv } from './NoFeatureMenu.styles';

interface IMenuContent {
  close: VoidFunction;
}
export function NoFeatureMenuContent(props: IMenuContent) {
  const { close } = props;
  return (
    <StyledDiv>
      <div className="OptionsSection">
        <Text text="h500">Options</Text>
        <BActionIcon onClick={close} />
      </div>
      <div>
        <Text text="p200" textColor="n600">
          Functionality not yet available for mobile. Check out the desktop
          version for more functionalities.
        </Text>
      </div>
    </StyledDiv>
  );
}
